import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Get all components saved by the user
export const getSavedComponents = () =>
  axios.get(`${API_URL}/library/saved`, { headers: getAuthHeaders() });

// Get all private components created by the user
export const getPrivateComponents = () =>
  axios.get(`${API_URL}/library/private`, { headers: getAuthHeaders() });

// Save a public component to the user's library
export const saveComponent = (componentId) =>
  axios.post(`${API_URL}/library/save`, { componentId }, { headers: getAuthHeaders() });

// Remove a saved component from the user's library
export const deleteSavedComponent = (componentId) =>
  axios.delete(`${API_URL}/library/saved/${componentId}`, { headers: getAuthHeaders() });

// Delete a private component created by the user
export const deletePrivateComponent = (componentId) =>
  axios.delete(`${API_URL}/library/private/${componentId}`, { headers: getAuthHeaders() });

// Utility to get JWT auth headers
function getAuthHeaders() {
  const token = localStorage.getItem('jwt');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
